import { Link2, Send } from "lucide-react";

import type { ManualDetail } from "@/api/db/manuals";
import { TerminologyWarnings } from "@/components/document-editor/warnings";
import { format } from "@/lib/format";

interface DocumentDetailsProps {
	manual: ManualDetail;
	warnings: ManualDetail["warnings"];
}

export function DocumentDetails({ manual, warnings }: DocumentDetailsProps) {
	return (
		<div className="flex flex-col gap-3 text-sm">
			<div className="rounded-md border border-border p-3">
				<p className="inline-flex items-center gap-1.5 font-semibold text-foreground">
					<Link2 className="size-3.5" />
					Identificador
				</p>

				<p className="mt-2 text-xs text-muted-foreground">
					Usado no link interno. A paciente não vê este campo.
				</p>

				<p className="mt-1 font-mono text-xs text-foreground">{manual.patient.slug}</p>
			</div>

			<div className="rounded-md border border-border p-3">
				<p className="inline-flex items-center gap-1.5 font-semibold text-foreground">
					<Send className="size-3.5" />
					Entrega
				</p>

				<div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
					<span>
						Acessos: <strong className="font-mono text-foreground">{manual.accessCount}</strong>
					</span>

					<span>
						Primeiro acesso:{" "}
						<strong className="font-mono text-foreground">
							{format.dateTime(manual.firstAccessAt) ?? "-"}
						</strong>
					</span>

					{manual.deliveredAt !== null && (
						<span>Entregue em {format.dateTime(manual.deliveredAt)}</span>
					)}
					{manual.revokedAt !== null && (
						<span>Revogado em {format.dateTime(manual.revokedAt)}</span>
					)}
				</div>
			</div>

			<TerminologyWarnings warnings={warnings} />
		</div>
	);
}
